import { Dropdown } from "@hawkins/components";
import React from "react";
import { useFormikDropdown } from "./useFormikDropdown";
const FormikDropdown = ({
  name,
  onBlur,
  onChange,
  onCreateOption,
  ...rest
}) => {
  const [formikDropdownProps] = useFormikDropdown(name, { onBlur, onChange, onCreateOption });
  return /* @__PURE__ */ React.createElement(Dropdown, { ...formikDropdownProps, ...rest });
};
export {
  FormikDropdown
};
//# sourceMappingURL=FormikDropdown.js.map
